module.exports = __webpack_public_path__ + "static/img/home-footer.3def360.png";